export const setFromProcessId = (value, setFieldValue, values, process) => {
    let processKey = process[value].processKey
    // console.log('processKey', processKey)
    values['processKey']=processKey
    setFieldValue('processKey', processKey)
    // console.log(value, process, values)
    
}